import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.sidemenu');
import { OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const STATUS_OPTIONS = [
    { value: 'in', label: '출근', color: '#10B981' },
    { value: 'away', label: '자리비움', color: '#F59E0B' },
    { value: 'trip', label: '출장', color: '#3B82F6' },
    { value: 'vacation', label: '휴가', color: '#A78BFA' },
    { value: 'out', label: '퇴근', color: '#9CA3AF' },
];

const COLLAPSE_HEIGHT = 700;
const COLLAPSE_WIDTH = 767;

@Component({
    selector: 'wiz-component-sidemenu',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.sidemenu/view.scss */
:host {
  display: block;
}

.sidebar-root {
  position: fixed;
  left: 0.9375rem;
  bottom: 1.5rem;
  z-index: 20;
}

.sidebar-body {
  border-radius: 2rem;
}

.sidebar-drawer {
  position: absolute;
  left: calc(100% + 1rem);
  top: 0;
}

.sidebar-drawer-wide {
  width: 18.75rem;
}

.sidebar-drawer-narrow {
  min-width: 7.5rem;
}

.sidebar-drawer-right {
  animation: sidebarSlideRight 0.15s ease-out;
}

.sidebar-drawer-closing {
  animation: sidebarSlideOut 0.15s ease-in forwards;
}

@keyframes sidebarSlideRight {
  from {
    opacity: 0;
    transform: translateX(-0.5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes sidebarSlideOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-0.5rem);
  }
}
.sidebar-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
  transform: scale(1.06);
}
.sidebar-btn:active {
  transform: scale(0.96);
}

.note-inbox-list {
  max-height: 171px;
  overscroll-behavior: contain;
}

.group:hover > .checkbox-hover-preview {
  background-color: rgba(253, 87, 51, 0.5);
  border-color: rgba(253, 87, 51, 0.5);
}

@keyframes noteBadgeShake {
  0%, 100% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(-3px) rotate(-5deg);
  }
  30% {
    transform: translateX(3px) rotate(5deg);
  }
  45% {
    transform: translateX(-2px) rotate(-3deg);
  }
  60% {
    transform: translateX(2px) rotate(3deg);
  }
  75% {
    transform: translateX(-1px) rotate(-1deg);
  }
}
.note-badge-shake {
  animation: noteBadgeShake 0.6s ease-in-out;
}

@media (max-width: 767px) {
  .sidebar-root {
    left: 1.5rem;
    bottom: 1.5rem;
  }
  .sidebar-body {
    border-radius: 1.5rem;
  }
  .hamburger-btn {
    width: 3rem !important;
    height: 3rem !important;
  }
  .expanded-menu {
    gap: 0.25rem;
  }
  .expanded-menu-item {
    width: 2.75rem !important;
    height: 2.75rem !important;
  }
  .sidebar-drawer-above {
    max-width: calc(100vw - 1rem);
  }
  .note-inbox-list {
    max-height: 130px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .sidebar-root {
    left: 2.5rem;
  }
}
.hamburger-btn {
  position: relative;
}

.expanded-menu {
  position: absolute;
  left: calc(100% + 0.5rem);
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.expanded-menu-item {
  transition: background-color 0.15s, transform 0.15s;
}
.expanded-menu-item:hover {
  background-color: #f0f0f0;
  transform: scale(1.06);
}
.expanded-menu-item:active {
  transform: scale(0.96);
}

.sidebar-drawer-above {
  left: auto;
  top: auto;
  position: fixed !important;
}
.sidebar-drawer-above.sidebar-drawer-right {
  animation: sidebarSlideUpCenter 0.15s ease-out;
}
.sidebar-drawer-above.sidebar-drawer-closing {
  animation: sidebarSlideDownCenter 0.15s ease-in forwards;
}

@keyframes sidebarSlideUpCenter {
  from {
    opacity: 0;
    transform: translate(-50%, 0.5rem);
  }
  to {
    opacity: 1;
    transform: translateX(-50%);
  }
}
@keyframes sidebarSlideDownCenter {
  from {
    opacity: 1;
    transform: translateX(-50%);
  }
  to {
    opacity: 0;
    transform: translate(-50%, 0.5rem);
  }
}`],
})
export class ComponentSidemenuComponent implements OnInit, OnDestroy {
    private _modalOpen: boolean = false;
    private _modalJustClosed: boolean = false;
    private _modalCloseTimeout: any = null;
    private _resizeHandler: (() => void) | null = null;

    @Input() set modalOpen(val: boolean) {
        const wasOpen = this._modalOpen;
        this._modalOpen = val;
        if (wasOpen && !val) {
            this._modalJustClosed = true;
            if (this._modalCloseTimeout) clearTimeout(this._modalCloseTimeout);
            this._modalCloseTimeout = setTimeout(() => { this._modalJustClosed = false; }, 150);
        }
    }
    get modalOpen(): boolean { return this._modalOpen; }

    @Input() myStatus: string = 'in';
    @Input() playerColor: string = '#4F8EF7';
    @Input() unreadNoteCount: number = 0;
    @Input() receivedNotes: Array<any> = [];
    @Input() players: Array<{ sid: string, nickname: string }> = [];
    @Input() myRole: string = 'user';
    @Input() intranetStatus: string = 'in';

    @Output() statusChange = new EventEmitter<string>();
    @Output() noteDetailOpen = new EventEmitter<any>();
    @Output() noteDelete = new EventEmitter<number>();
    @Output() noteComposeModalOpen = new EventEmitter<void>();
    @Output() sentNoteDetailOpen = new EventEmitter<any>();
    @Output() myInfoOpen = new EventEmitter<void>();
    @Output() logoutRequest = new EventEmitter<void>();
    @Output() goToSeat = new EventEmitter<void>();

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private elRef: ElementRef) { }

    public statusOptions = STATUS_OPTIONS;
    public sideMenuStatusOpen: boolean = false;
    public isStatusClosing: boolean = false;
    public noteInboxOpen: boolean = false;
    public isNoteClosing: boolean = false;

    public dbNotes: Array<any> = [];
    public unreadDbNoteCount: number = 0;
    public noteSelectedIds: Set<string> = new Set();
    public noteTab: string = 'inbox';
    public dbSentNotes: Array<any> = [];
    public sentNoteSelectedIds: Set<string> = new Set();

    // 반응형 접힘 상태
    public isCollapsed: boolean = false;
    public isNarrow: boolean = false;
    public isMenuExpanded: boolean = false;

    // 뱃지 흔들림 애니메이션
    public badgeShaking: boolean = false;
    private badgeShakeTimeout: any = null;

    // 접힘 모드 드로어 위치 (버튼 중앙 위)
    public drawerLeft: number | null = null;
    public drawerBottom: number | null = null;

    public async ngOnInit() {
        await this.service.init();
        this.checkViewport();
        this._resizeHandler = () => { this.checkViewport(); };
        window.addEventListener('resize', this._resizeHandler);
        await this.loadDbNotes();
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this._modalCloseTimeout) clearTimeout(this._modalCloseTimeout);
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
            this._resizeHandler = null;
        }
    }

    private checkViewport() {
        const wasCollapsed = this.isCollapsed;
        const wasNarrow = this.isNarrow;
        this.isNarrow = window.innerWidth <= COLLAPSE_WIDTH;
        this.isCollapsed = window.innerHeight < COLLAPSE_HEIGHT || this.isNarrow;
        if (wasCollapsed !== this.isCollapsed || wasNarrow !== this.isNarrow) {
            if (this.sideMenuStatusOpen) { this.sideMenuStatusOpen = false; this.isStatusClosing = false; }
            this.drawerLeft = null;
            this.drawerBottom = null;
            this.service.render();
        }
    }

    private calcDrawerPosition(event: MouseEvent) {
        if (!this.isCollapsed) {
            this.drawerLeft = null;
            this.drawerBottom = null;
            return;
        }
        const btn = (event.currentTarget as HTMLElement);
        const rect = btn.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const topY = rect.top;
        this.drawerLeft = centerX;
        this.drawerBottom = window.innerHeight - topY + 16;
    }

    public async toggleMenu() {
        if (this.isMenuExpanded) {
            if (this.sideMenuStatusOpen) this.closeDrawer('status');
            if (this.noteInboxOpen) this.closeDrawer('note');
            this.isMenuExpanded = false;
        } else {
            this.isMenuExpanded = true;
        }
        await this.service.render();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.sideMenuStatusOpen && !this.noteInboxOpen && !this.isMenuExpanded) return;
        if (this.modalOpen || this._modalJustClosed) return;
        if (this.elRef.nativeElement.contains(event.target)) return;
        if (this.sideMenuStatusOpen && !this.isStatusClosing) this.closeDrawer('status');
        if (this.noteInboxOpen && !this.isNoteClosing) this.closeDrawer('note');
        if (this.isMenuExpanded) {
            this.isMenuExpanded = false;
            this.service.render();
        }
    }

    private closeDrawer(type: string) {
        if (type === 'status') {
            this.isStatusClosing = true;
            this.service.render();
            setTimeout(async () => { this.sideMenuStatusOpen = false; this.isStatusClosing = false; await this.service.render(); }, 150);
        } else if (type === 'note') {
            this.isNoteClosing = true;
            this.service.render();
            setTimeout(async () => { this.noteInboxOpen = false; this.isNoteClosing = false; this.noteSelectedIds.clear(); await this.service.render(); }, 150);
        }
    }

    public getStatusColor(status: string): string {
        const opt = STATUS_OPTIONS.find(o => o.value === status);
        return opt ? opt.color : '#9CA3AF';
    }

    public getStatusLabel(status: string): string {
        const opt = STATUS_OPTIONS.find(o => o.value === status);
        return opt ? opt.label : '알 수 없음';
    }

    public async toggleStatusDrawer(event?: MouseEvent) {
        if (this.sideMenuStatusOpen) { this.closeDrawer('status'); }
        else {
            if (this.noteInboxOpen) this.closeDrawer('note');
            if (event) this.calcDrawerPosition(event);
            this.sideMenuStatusOpen = true; await this.service.render();
        }
    }

    public async changeStatus(status: string) {
        this.sideMenuStatusOpen = false;
        this.statusChange.emit(status);
        await this.service.render();
    }

    public async openMyInfo() { this.myInfoOpen.emit(); }
    public async onLogout() { this.logoutRequest.emit(); }
    public async onGoToSeat() { this.goToSeat.emit(); }

    public async loadDbNotes() {
        try {
            let res = await wiz.call("note_inbox", { page: 1, dump: 50 });
            if (res.code === 200) {
                this.dbNotes = res.data.rows || [];
                this.unreadDbNoteCount = res.data.unread || 0;
            }
        } catch (e) { }
        await this.service.render();
    }

    public async loadDbSentNotes() {
        try {
            let res = await wiz.call("note_outbox", { page: 1, dump: 50 });
            if (res.code === 200) {
                this.dbSentNotes = res.data.rows || [];
            }
        } catch (e) { }
        await this.service.render();
    }

    public async switchNoteTab(tab: string) {
        this.noteTab = tab;
        if (tab === 'outbox') {
            await this.loadDbSentNotes();
        }
        await this.service.render();
    }

    public triggerBadgeShake() {
        this.badgeShaking = true;
        if (this.badgeShakeTimeout) clearTimeout(this.badgeShakeTimeout);
        this.badgeShakeTimeout = setTimeout(() => {
            this.badgeShaking = false;
            this.service.render();
        }, 600);
        this.service.render();
    }

    public async toggleNoteInbox(event?: MouseEvent) {
        if (this.noteInboxOpen) { this.closeDrawer('note'); }
        else {
            if (this.sideMenuStatusOpen) this.closeDrawer('status');
            if (event) this.calcDrawerPosition(event);
            this.noteInboxOpen = true;
            this.noteSelectedIds.clear();
            this.noteTab = 'inbox';
            await this.loadDbNotes();
            await this.service.render();
        }
    }

    public toggleNoteSelect(id: string) {
        if (this.noteSelectedIds.has(id)) this.noteSelectedIds.delete(id);
        else this.noteSelectedIds.add(id);
        this.service.render();
    }

    public toggleNoteSelectAll() {
        if (this.noteSelectedIds.size === this.dbNotes.length) {
            this.noteSelectedIds.clear();
        } else {
            this.dbNotes.forEach(n => this.noteSelectedIds.add(n.id));
        }
        this.service.render();
    }

    public async markNoteRead(noteId: string) {
        if (!noteId) return;
        try {
            await wiz.call("note_read", { ids: noteId });
        } catch (e) { }
        await this.loadDbNotes();
        await this.service.render();
    }

    public async markSelectedNotesRead() {
        if (this.noteSelectedIds.size === 0) return;
        try {
            await wiz.call("note_read", { ids: Array.from(this.noteSelectedIds).join(',') });
        } catch (e) { }
        this.noteSelectedIds.clear();
        await this.loadDbNotes();
        await this.service.render();
    }

    public async deleteSelectedNotes() {
        if (this.noteSelectedIds.size === 0) return;
        try {
            await wiz.call("note_delete", { ids: Array.from(this.noteSelectedIds).join(',') });
        } catch (e) { }
        this.noteSelectedIds.clear();
        await this.loadDbNotes();
        await this.service.render();
    }

    public async markAllNotesRead() {
        try { await wiz.call("note_read_all"); } catch (e) { }
        await this.loadDbNotes();
        await this.service.render();
    }

    public async deleteAllNotes() {
        try { await wiz.call("note_delete_all"); } catch (e) { }
        await this.loadDbNotes();
        await this.service.render();
    }

    public toggleSentNoteSelect(id: string) {
        if (this.sentNoteSelectedIds.has(id)) this.sentNoteSelectedIds.delete(id);
        else this.sentNoteSelectedIds.add(id);
        this.service.render();
    }

    public toggleSentNoteSelectAll() {
        if (this.sentNoteSelectedIds.size === this.dbSentNotes.length) {
            this.sentNoteSelectedIds.clear();
        } else {
            this.dbSentNotes.forEach(n => this.sentNoteSelectedIds.add(n.id));
        }
        this.service.render();
    }

    public async deleteSelectedSentNotes() {
        if (this.sentNoteSelectedIds.size === 0) return;
        try {
            await wiz.call("note_delete_sent", { ids: Array.from(this.sentNoteSelectedIds).join(',') });
        } catch (e) { }
        this.sentNoteSelectedIds.clear();
        await this.loadDbSentNotes();
        await this.service.render();
    }
}

export default ComponentSidemenuComponent;